// eslint-disable-next-line no-restricted-imports
import styled from 'styled-components';
import { devices } from 'utils/styledHelpers';

export const ModalBody = styled.div`
  .modal-explanation {
    display: grid;
    gap: 10px;
    grid-template-columns: 1fr 1fr;
    ${devices.mobile} {
      grid-template-columns: 1fr;
    }

    .explanation {
      border: 1px solid #f3f3fc;
      border-radius: 10px;
      padding: 20px;

      h2 {
        color: #312f4f;
        font-size: 16px;
        font-weight: 700;
        line-height: 150%;
        margin-bottom: 10px;
      }

      p {
        color: #312f4f;
        font-size: 15px;
        font-weight: 400;
        line-height: 150%;
        margin-bottom: 16px;
      }
    }
  }
  .costs {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 20px;
    margin-top: 40px;

    .costs-title {
      color: #312f4f;
      font-size: 16px;
      font-weight: 700;
      line-height: 150%;
      text-align: center;
    }
    ${devices.mobile} {
      flex-direction: column;
    }
    .costs-content {
      display: flex;
      flex-direction: row;
      gap: 44px;

      ${devices.mobile} {
        flex-direction: column;
      }

      .costs-item {
        align-items: center;
        border: 2px solid #e6eeff;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        font-size: 13px;
        font-weight: 400;
        justify-content: center;
        line-height: 120%;
        max-width: 150px;
        min-height: 65px;
        padding: 5px 15px;
        position: relative;
        text-align: center;

        &:not(:last-child) {
          &:before {
            align-items: center;
            background-color: #e6eeff;
            border-radius: 100%;
            content: '+';
            display: flex;
            font-size: 16px;
            font-weight: 700;
            height: 24px;
            justify-content: center;
            line-height: 150%;
            position: absolute;
            right: -36px;
            width: 24px;
            ${devices.mobile} {
              bottom: -36px;
              right: 40%;
            }
          }
        }
        strong {
          font-size: 15px;
          font-weight: 600;
          line-height: 150%;
        }
      }
    }
  }

  .modal-link {
    margin-top: 40px;
    text-align: center;
    a {
      color: #312f4f;
      font-size: 15px;
      font-weight: 400;
      line-height: 150%;
      text-align: center;
      text-decoration-line: underline;
    }
  }
`;
